import { View } from 'react-native';
import { styles } from './UserImageAreaGridOverlay.style';
import { PreviewGrid } from '@photosi/rn-components/preview-content/PreviewGrid';
import { neutrals } from 'src/theme/colors';

export const UserImageAreaGridOverlay = ({ extBorderColor = neutrals.white }: { extBorderColor?: string }) => {
  return (
    <View style={[styles.gridContainer, { borderColor: extBorderColor }]}>
      <PreviewGrid strokeColor={neutrals.white} />
      {/* <View style={[styles.corner, styles.cornerBottomLeft, { borderColor: extBorderColor }]} />
      <View style={[styles.corner, styles.cornerBottomRight, { borderColor: extBorderColor }]} />
      <View style={[styles.corner, styles.cornerTopLeft, { borderColor: extBorderColor }]} />
      <View style={[styles.corner, styles.cornerTopRight, { borderColor: extBorderColor }]} /> */}
    </View>
  );
};
